export const razones = [
    {
        id: 1,
        aos: "fade-up",
        texto: "Es una ciencia muy joven que hay mucho por descubrir, ya que la tecnología avanza más y más; abre la lógica para poder entender la funcionalidad de los procesos, hay variedades de estudio, en las ciencias se encuentra: Gestión de Bases de Datos, Desarrollo de Software, Gestión de Redes, el Desarrollo de Aplicaciones Web, Gestión de Servidores y mucho más. ",
        img: require('./assets/img/inicio/Foto1Info.AVIF'),
        direccion: "derecha"
    },
    {
        id: 2,
        aos: "fade-left",
        texto: "Es una carrera muy extensa tanto en habilidades técnicas como en desarrollo empresarial, lo que permite estar en un constante aprendizaje ya que la tecnología avanza todos los días y formando parte de esta carrera se puede contribuir a la evolución de la misma.",
        img: require('./assets/img/inicio/Foto2Info.AVIF'),
        direccion: "izquierda"
    },
    {
        id: 3,
        aos: "fade-right",
        texto: "Es una carrera en la que no te sientes encapsulado, siempre permite ir un paso más adelante, gracias a que es una carrera en auge, siendo considerada 'la carrera del futuro'. Da la oportunidad de no quedarse estancado, sino de desarrollarse de la mejor manera, haciéndola una carrera perfecta. ",
        img: require('./assets/img/inicio/Foto3Info.AVIF'),
        direccion: "derecha"
    }
]